import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">H</span>
              </div>
              <span className="text-background-50 font-heading font-bold text-xl">qiaojzx.cn</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              一站式综合服务平台，为您提供安全、便捷、高效的在线服务体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">服务分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-400 hover:text-background-100 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/usage-tutorial" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  使用教程
                </Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/category/register-login" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  注册登录
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-start gap-2 text-background-400 text-sm">
                <i className="ri-phone-line mt-0.5"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-background-400 text-sm">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@qiaojzx.cn</span>
              </li>
              <li className="flex items-start gap-2 text-background-400 text-sm">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>上海市浦东新区张江高科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 qiaojzx.cn. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">服务协议</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}